<template>
    <div id="app" :style="{'overflow-y': overflow}" :class="{'no-background': path === 'softIntroduction'}">
        
        <Layout v-if="!(path === 'softIntroduction' || path === 'wh5' || path == 'iframePay')"></Layout>

        <!-- 软件导购问答单独使用router-view -->
        <router-view v-if="(path === 'softIntroduction' || path === 'wh5' || path == 'iframePay')"></router-view>
        
    </div>
</template>
<script>
export default {
    name: 'app',
    data: ()=>({
        overflow: 'auto',
        background: ''
    }),
    provide () {
        var  self = this
        return {
            appOverFlow (x) {
                self.overflow = x
            }
        }
    },
    computed: {
        path () {
            return this.$route.name
        }
    },
    async created () {
        function isIE11 () {
            if (window.navigator.userAgent.indexOf("Trident")>-1 && window.navigator.userAgent.indexOf("rv:11.0")>-1) return true
            else return false
        }
        if (isIE11()) {
            this.$market.alert({
                content: '检测到您正在使用ie内核的浏览器，请检查您的浏览器是否是兼容模式，请切换到极速模式使用，或者推荐直接使用谷歌或火狐浏览器访问。'
            })
        }

        /** 
         * 运营部 - 3 - 柏慧（说明书）(baih) 13:04:38
         * 789软件网购付费功能对应的菜单，我们有办法链接到装备超市对应的软件页吗
         * 运营部 - 3 - 柏慧（说明书）(baih) 13:06:46
         * 软件不改菜单链接的前提下
        */
        let queries = new URLSearchParams(location.search || '')
        let whid = queries.get('whid')
        let isrenew = queries.get('isrenew')
        switch (whid) {
            case 'webmaster7':
            case 'webwh7':
                if (isrenew) {
                    this.$router.push('/detail/76?isrenew=1')
                } else {
                    this.$router.push('/detail/76')
                }
                break
            case 'webmaster8':
            case 'webwh8':
                if (isrenew) {
                    this.$router.push('/detail/1?isrenew=1')
                } else {
                    this.$router.push('/detail/1')
                }
                break
            case 'webmaster9':
            case 'webwh9':
                if (isrenew) {
                    this.$router.push('/detail/124?isrenew=1')
                } else {
                    this.$router.push('/detail/124')
                }
                break
            case 'webwh3':
                if (isrenew) {
                    this.$router.push('/detail/139?isrenew=1')
                } else {
                    this.$router.push('/detail/139')
                }
                break

        }

        Promise.all([
            this.$axios({
                url: location.origin + "/",
                method: "head"
            }),
            this.$axios({
                url: location.origin + "/?t=" + Date.now(),
                method: "head"
            }),
        ]).then(([res1, res2]) => {
            console.log(res1, res2)
            if (res1.headers.etag != res2.headers.etag) {
                this.$market.alert({
                    content: '<div style="padding-left: 60px;">当前页面可能不是最新的 <br> 请 ctrl + F5 刷新一下页面</div>'
                })
            }
        })
    }
}
</script>
<style>
    body {
        overflow-x: auto;
    }
    /* #app::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 34.5%;
        background: linear-gradient(to right, rgb(253, 253, 253) 0%,rgb(244, 245, 247) 100%);
        z-index: 1;
    } */
    #app.no-background::before {
        display: none;
    }
    #app.no-background::after {
        display: none;
    }
    #app {
        font-family: 'microsoft yahei';
        font-size: 12px;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: left;
        color: #2c3e50;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 10;
        /* background: rgb(0, 101, 173); */
        /* background: url(./assets/image/body_bg.jpg) no-repeat center top; */
    }
    
    #nav {
        padding: 30px;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    #nav a.router-link-exact-active {
        color: #42b983;
    }

</style>